import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
const volumes = [{
  emoji: '📘',
  num: 'VOLUMEN 1',
  title: 'El Sistema Nervioso al Descubierto',
  desc: 'Por qué tu cerebro entra en pánico. Neurociencia, tipos de ansiedad y tu perfil personal de ansiedad.',
  color: '#FBBF24'
}, {
  emoji: '📗',
  num: 'VOLUMEN 2',
  title: 'El Sistema de Intervención Inmediata',
  desc: 'Protocolos de 30 a 90 segundos para frenar el ataque donde estés, sin que nadie lo note.',
  color: '#F59E0B'
}, {
  emoji: '📙',
  num: 'VOLUMEN 3',
  title: 'El Sistema de Reprogramación Mental',
  desc: 'TCC, ACT, EMDR y neuroplasticidad para cambiar el patrón de ansiedad de raíz.',
  color: '#F97316'
}, {
  emoji: '📕',
  num: 'VOLUMEN 4',
  title: 'El Sistema Corporal',
  desc: 'Nutrición, sueño, biohacking nervioso y movimiento para bajar la ansiedad de base.',
  color: '#EF4444'
}, {
  emoji: '📓',
  num: 'VOLUMEN 5',
  title: 'El Sistema de Entorno',
  desc: 'Relaciones, trabajo y vida social sin que el mundo exterior dispare tu ansiedad.',
  color: '#E11D48'
}, {
  emoji: '📒',
  num: 'VOLUMEN 6',
  title: 'El Sistema de Vida',
  desc: 'Tu plan maestro de mantenimiento para vivir sin ansiedad de por vida.',
  color: '#DC2626'
}];
export function ProductSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-4 px-4 bg-primary" ref={ref} data-id="element-155">
      <div className="max-w-6xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-3" data-id="element-157">
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-158">
            ¿Qué incluye el pack completo?
          </h2>
          <p className="text-text-secondary text-sm sm:text-base" data-id="element-159">
            6 Volúmenes · 360 páginas · Todo en PDF · Acceso inmediato y de por
            vida
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-160">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} style={{
          borderLeftColor: vol.color
        }} className="bg-card border border-gray-200 border-l-[4px] shadow-sm rounded-md py-2.5 px-3 hover:-translate-y-1 transition-all duration-300 flex items-center" onMouseEnter={e => {
          e.currentTarget.style.boxShadow = `0 4px 15px ${vol.color}33`;
        }} onMouseLeave={e => {
          e.currentTarget.style.boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.05)';
        }} data-id="element-161">
              <div className="text-lg mr-2 shrink-0" data-id="element-162">{vol.emoji}</div>
              <div data-id="element-163">
                <span style={{
              color: vol.color
            }} className="text-[10px] font-bold tracking-wider block" data-id="element-164">
                  {vol.num}
                </span>
                <h3 className="text-slate-900 font-bold text-sm leading-tight" data-id="element-165">
                  {vol.title}
                </h3>
                <p className="text-text-secondary text-xs leading-snug" data-id="element-166">
                  {vol.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}